import React, { useEffect, memo } from 'react'
import SubSection from '../SubSection'
import FaqDetailModal from '../FaqDetailModal'
import FaqQuestionItem from '../FaqQuestionItem'
import { TEXT } from '../../shared/styles/colors'
import useBehavior from '../../templates/Faq/useBehavior'
import useBreakpoints from '../../hooks/useBreakpoints/index.js'
import * as Styled from './styled'
import useStyles from './material-style'
import Search from '@material-ui/icons/Search'

import {
  Container,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput
} from '@material-ui/core'

const FaqSection = ({ onlyQuestions, style }) => {
  const {
    handleClickQuestion,
    handleCloseDialog,
    isModalOpen,
    questions,
    selectedQuestion,
    handleHomeFaq,
    updateSearch
  } = useBehavior()

  const { isDesk, isMobile } = useBreakpoints()
  const classes = useStyles()

  const homeFaqTimeout = () => setTimeout(() => { handleHomeFaq() }, 500)

  const handleSearch = evt => {
    const value = evt.currentTarget.value
    if (value) {
      updateSearch(evt)
    } else {
      homeFaqTimeout()
    }
  }

  useEffect(() => {
    homeFaqTimeout()
  }, [])

  return (
    <>
      { onlyQuestions ?
        <article style={style}>
          <FaqQuestionItem
            withBorder
            questions={questions}
            handleClickQuestion={handleClickQuestion}
            fullWidth={true}
          />
          <FaqDetailModal
            isDesk={isDesk}
            data={selectedQuestion}
            open={isModalOpen}
            onCancel={handleCloseDialog}
          />
        </article>
        :
        <SubSection
          sup='Sem Dúvidas'
          color={TEXT}
          title='Perguntas Frequentes'
          titleStyle={{ paddingTop: 0 }}
          wrapperStyle={{ borderBottom: '1px solid #C6D2EC' }}
        >
          <>
            <Styled.Content>
              <FormControl variant='outlined' className={classes[isMobile ? 'formControlMobile' : 'formControl']}>
                <InputLabel htmlFor='search-input'>Qual a sua dúvida?</InputLabel>
                <OutlinedInput
                  id='search-input'
                  endAdornment={
                    <InputAdornment position='end'>
                      <IconButton aria-label='Procurar' edge='end'>
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  }
                  labelWidth={145}
                  onChange={handleSearch}
                />
              </FormControl>
              <Styled.SectionTitle>Mais relevantes</Styled.SectionTitle>

              <FaqQuestionItem
                withBorder
                questions={questions}
                handleClickQuestion={handleClickQuestion}
              />
              <FaqDetailModal
                isDesk={isDesk}
                data={selectedQuestion}
                open={isModalOpen}
                onCancel={handleCloseDialog}
              />
            </Styled.Content>
          </>
        </SubSection>
      }
    </>
  )
}

export default memo(FaqSection)
